import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseOrder from '@/use/usePurchaseOrder';

const { statusClassMap, statusTranslate } = usePurchaseOrder();

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => statusTranslate(val),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return statusClassMap(val);
        },
      },
    },
    description: {
      name: 'วัสดุ',
      width: '1fr',
    },
    amount: {
      name: 'จำนวนที่สั่ง',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    filled_amount: {
      name: 'จำนวนที่ได้รับแล้ว',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
    },
    target_date: {
      name: 'กำหนดส่ง',
      width: '10rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    created_at: {
      name: 'วันทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },

  },

};
